export default {
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (!this.field.length || value.length <= this.field.length) {
          this.$emit('update:modelValue', value);
        }
      },
    },
  },
};
